import React, { useEffect } from 'react';
import './content-manager-container.styles.scss';
import ContentManager from './content-manager.component';
import { useSelector } from 'react-redux';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const ContentManagerContainer = () => {

    const screenSize = useSelector(state => state.contentData.screenSize);

    useEffect(() => {
        changeDocumentTitle('Gamably | My Content');
    }, []);

    return (
        <div className={`content-manager-container ${screenSize}`}>
            <div className={`g-card ${screenSize}`}>
                <div className='section-title'>
                    Content Manager
                </div>
                {
                    screenSize === 'mobile' &&
                    <div className='g-space-1'></div>
                }
                <div className={screenSize !== 'mobile' && 'g-list-item'}>
                    <ContentManager />
                </div>
            </div>
        </div>
    )
}

export default ContentManagerContainer